import * as React from "react";

const { Component } = React;

import { toPairs } from "lodash";

import * as IdentityProviderStore from "./IdentityProviderStore";
import { alert } from "../general/alertStore";
import { Input } from "reactstrap";

interface CreateIdentityProviderProps {
    organization: string;
}

interface CreateIdentityProviderState {
    identityProvider: {
        id: string;
        sourceID: string;
        type: string;
        priority: number;
        organizationID: string;
    };
    isLoaded: boolean;
    error?: any;
}

export const IdentityProviderTypes = {
    "0": "Azure Active Directory",
    "1": "Google",
    "2": "Apple",
    "3": "Facebook",
};

export default class CreateIdentityProvider extends Component<CreateIdentityProviderProps, CreateIdentityProviderState> {
    constructor(props) {
        super(props);
        this.state = {
            identityProvider: {
                id: undefined,
                sourceID: undefined,
                type: undefined,
                priority: undefined,
                organizationID: props.organization,
            },
            isLoaded: false,
        };
    }

    createIdentityProvider = () => {
        if (!this.state.identityProvider.type) {
            alert("Choose a Identity Provider type");
            return;
        }

        IdentityProviderStore.CreateIdentityProvider(this.state.identityProvider).then(
            (result) => {
                this.setState({
                    isLoaded: true,
                    identityProvider: result,
                });
            },
            (error) => {
                this.setState({
                    isLoaded: true,
                    error,
                });
            }
        );
    };

    handleSourceIdChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.identityProvider.sourceID = name;

            return prevState;
        });
    };

    handleTypeChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.identityProvider.type = name;

            return prevState;
        });
    };

    handlePriorityChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.identityProvider.priority = name;

            return prevState;
        });
    };

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Source ID</label>
                    <div className="col-sm-9 pl-0">
                        <input type="text" className="form-control" onChange={this.handleSourceIdChange} />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Type</label>
                    <div className="col-sm-9 pl-0">
                        <Input type="select" onChange={this.handleTypeChange} defaultValue="">
                            <option value="">- Choose One -</option>
                            {toPairs(IdentityProviderTypes).map((pair) => (
                                <option value={pair[0]} key={pair[0]}>
                                    {pair[1]}
                                </option>
                            ))}
                        </Input>
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Priority</label>
                    <div className="col-sm-9 pl-0">
                        <input type="text" className="form-control" onChange={this.handlePriorityChange} />
                    </div>
                </div>

                <div className="d-flex align-items-end flex-column h-100">
                    <div className="mb-1">
                        <button className="btn btn-primary float-right" onClick={this.createIdentityProvider}>
                            Create
                        </button>
                    </div>
                </div>
                {this.state.isLoaded && (
                    <div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">ID</label>
                            <div className="col-sm-9 p-2">{this.state.identityProvider.id}</div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Soruce ID</label>
                            <div className="col-sm-9 p-2">{this.state.identityProvider.sourceID}</div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Type</label>
                            <div className="col-sm-9 p-2">{IdentityProviderTypes[this.state.identityProvider.type]}</div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
